export default function Mentions() {
  return {}
}
